import { PortModel } from 'models/PortModel';
import { VesselModel } from 'models/VesselModel';
import { YardModel } from 'models/YardModel';

export enum VoyageStatus {
    Pending = 'pending',
    Loaded = 'loaded',
    Departed = 'departed',
    Arrived = 'arrived',
    Canceled = 'canceled',
    Lost = 'lost',
}

export type VoyageData = {
    vesselId: number,
    polId: number,
    podId: number,
    customsYardId: number,
    number: string,
    cutDate: string,
    carDeliveryStartDate: string,
    carDeliveryEndDate: string,
    loadingStartDate: string,
    loadingEndDate: string,
    etd: string,
    eta: string,
    blIssueDate: string,
    freightPrice: number,
    allowDismantled: boolean,
}

export type VoyageModel = {
    id: number,
    status: VoyageStatus,
    pod: PortModel,
    pol: PortModel,
    customsYard: YardModel,
    vessel: VesselModel,
    cars: {
        total: number,
        dis: number,
        caf: number,
        fob: number,
        paidCaf: number,
        paidFob: number,
        capacity: number,
    },
    departedAt: string,
    arrivedAt: string,
    note: string,
    eds?: {
        [companyId: number]: {
            id: number,
            createdAt: string,
        }
    },
} & VoyageData;
